export const DURATION = {
  fast: 0.15,
  medium: 0.2,
  slow: 0.25,
};

export const EASING = {
  snappy: [0.2, 0.0, 0.05, 1.0] as const, // Custom spring-like cubic bezier
  smooth: 'easeInOut' as const,
  spring: {
    type: 'spring' as const,
    stiffness: 500,
    damping: 25,
  },
};

export const commonVariants = {
  fadeIn: {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { duration: DURATION.medium, ease: EASING.smooth },
    },
    exit: {
      opacity: 0,
      transition: { duration: DURATION.medium, ease: EASING.smooth },
    },
  },
  slideUp: {
    hidden: { opacity: 0, y: 10 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: DURATION.medium, ease: EASING.snappy },
    },
    exit: {
      opacity: 0,
      y: 10,
      transition: { duration: DURATION.medium, ease: EASING.snappy },
    },
  },
  scale: {
    hidden: { scale: 0 },
    visible: {
      scale: 1,
      transition: EASING.spring,
    },
  },
};

export const answerItemVariants = {
  hidden: { opacity: 0, scale: 0.96, x: -5 },
  visible: {
    opacity: 1,
    scale: 1,
    x: 0,
    transition: { duration: DURATION.fast, ease: EASING.snappy },
  },
  exit: {
    opacity: 0,
    scale: 0.96,
    x: -5,
    transition: { duration: DURATION.fast, ease: EASING.snappy },
  },
};

export const questionContainerVariants = {
  ...commonVariants.fadeIn,
  visible: {
    opacity: 1,
    transition: { duration: DURATION.medium, ease: EASING.smooth },
  },
};

export const cardVariants = {
  ...commonVariants.slideUp,
};

export const linkedCourseItemVariants = {
  hidden: { opacity: 0, y: 5 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: DURATION.medium, ease: EASING.snappy },
  },
  exit: {
    opacity: 0,
    height: 0,
    marginTop: 0,
    marginBottom: 0,
    transition: { duration: DURATION.medium, ease: EASING.snappy },
  },
} as const;

export const formVariants = {
  ...commonVariants.slideUp,
};
